import React from "react"

import fullCheck from "images/full-check.svg"

const EmptyStateDataCheck = (props) => {
  return (
    <div className="data-check-empty-state">
      <img src={fullCheck} alt="data-check" />
      <p style={{ color: "#4F4F4F", marginBottom: "0px" }}>
        <strong>¡Destinatarios listos!</strong>
      </p>
      <div className="data-check-empty-state-description">
        Todos los colaboradores cuentan con un único cuestionario asociado.
      </div>
    </div>
  )
}

export default EmptyStateDataCheck
